import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NotificationApi } from "../../shared/api/NotificationApi";
import { RootState } from "../store";
import { AnnouncementsApi } from "../../shared/api/AnnouncementsApi";

interface Notification {
    id: number;
    userId: number;
    message: string;
    notificationType: string;
    projectId: number;
    createdDate: string;
    read: boolean;
}

interface NotificationState {
    notifications: Notification[];
    loading: boolean;
    error: string | null;
    activeTab: string;
    count: number;
    announcements: any[];
}

const initialState: NotificationState = {
    notifications: [],
    loading: false,
    error: null,
    activeTab: "Overview",
    count: 0,
    announcements: [],
};


const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        setActiveTab: (state, action: PayloadAction<string>) => {
            state.activeTab = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                NotificationApi.endpoints.getNotifications.matchFulfilled,
                (state, action) => {
                    if (action.payload) {
                        state.notifications = action.payload.data.timeLogs;
                    }
                }
            )

            .addMatcher(
                NotificationApi.endpoints.getNotificationCount.matchFulfilled,
                (state, action: PayloadAction<{ data: number }>) => {
                    if (action.payload) {
                        state.count = action.payload.data;
                    }
                }
            )

            .addMatcher(
                AnnouncementsApi.endpoints.getUnReadAnnouncement.matchFulfilled,
                (state, action) => {
                    if (action.payload) {
                        state.announcements = action.payload; // Store the API response
                    }
                }
            );
    }
})
export const { setActiveTab } = notificationSlice.actions;
export const selectActiveTab = (state: RootState) => state.notification.activeTab;
export const selectNotifications = (state: RootState) => state.notification.notifications;
export const selectNotificationCount = (state: RootState) => state.notification.count;
export const selectAnnouncements = (state: RootState) => state.notification.announcements;
export default notificationSlice;
